export enum DataRoomEntryType {
  CUSTOM = "custom",
  STATIC = "static",
}
